export const projectRoutes: { [project: string]: string[] } = {
  "Motion2Coach Golf": [
    "/m2c-dashboard",
    "/m2c-golf-history",
    "/m2c-golf-stats",
  ],
  "Motion2Coach Athletics": [
    "/athletics-dashboard",
    "/m2c-athletics-stats",
    "/m2c-athletics-history",
  ],
  "Motion2Coach Launch": [
    "/launch-dashboard",
    "/m2c-launch-stats",
    "/m2c-launch-history",
  ],
  "Motion2Coach Simulation": [
    "/simulation-dashboard",
    "/simulation-history",
    "/benchmark-history",
  ],
  "Motion2Coach Analytics": [
    "/m2c-analytics",
    "/user-history",
    "/internal-dashboard",
  ],
};

export const dashboardRoutes: string[] = [
  "/launch-dashboard",
  "/m2c-launch-stats",
  "/m2c-launch-history",
  "/athletics-dashboard",
  "/m2c-athletics-stats",
  "/m2c-athletics-history",
  "/m2c-dashboard",
  "/m2c-golf-history",
  "/m2c-golf-stats",
  "/simulation-dashboard",
  "/simulation-history",
  "/m2c-analytics",
  "/user-history",
  "/internal-dashboard",
];

export const persistUserDetailState = ["/m2c-analytics", "/user-history"];

export const settingsRoute = "/settings";
export const admin = "admin";
